import styles from './WebinarTheses.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const WebinarTheses = ({ props }) => {
  return (
    <section className={classnames(isMobile ? [styles.section, styles.mobile] : [styles.section])}>
      <h2 className={classnames(isMobile ? [styles.sectionTitle, styles.mobile] : [styles.sectionTitle])}>
        Содержание
      </h2>

      <ul className={classnames(isMobile ? [styles.list, styles.mobile] : [styles.list])}>
        {props.map((item) => {
          return (
            <li key={item.id} className={classnames(isMobile ? [styles.item, styles.mobile] : [styles.item])}>
              <h3 className={classnames(isMobile ? [styles.title, styles.mobile] : [styles.title])}>{item.title}</h3>
              <p className={classnames(isMobile ? [styles.text, styles.mobile] : [styles.text])}>{item.text}</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default WebinarTheses;
